import type { AgentContent } from 'components/chat-components/AgentMessage.types'

export const getContentSignature = (content: AgentContent): string => {
  switch (content.type) {
    case 'text': {
      return `${content.type}:${content.text}`
    }
    case 'video_artifact': {
      return `${content.type}:${content.videoUrl}`
    }
    case 'video_segment': {
      return `${content.type}:${content.segment.startTime}-${content.segment.endTime}:${content.label ?? ''}`
    }
    case 'video_side_by_side': {
      const clipSignature = content.clips.map(clip => `${clip.fileId}:${clip.startTime}-${clip.endTime}`).join('|')
      return `${content.type}:${clipSignature}`
    }
    case 'youtube_video': {
      return `${content.type}:${content.videoId}:${content.startSeconds}-${content.endSeconds}`
    }
    case 'function_call': {
      return `${content.type}:${content.id}`
    }
    case 'function_result': {
      return `${content.type}:${content.callId}:${content.name}`
    }
    case 'thinking': {
      return `${content.type}:${content.thought}`
    }
    default: {
      return 'unknown'
    }
  }
}
